const membershipDiscountMoney = (value) => {
	const amount = parseFloat(value || 0);
	return Number.isFinite(amount) ? amount : 0;
};

const membershipDiscountAppliesToAll = (discount) => (
	discount.target === "all_items"
	|| discount.target === "all"
	|| discount.applies_to_all === true
	|| discount.applies_to_all === 1
	|| discount.applies_to_all === "1"
);

const membershipDiscountType = (discount) => {
	if (discount.discount_type === "amount" || discount.discount_type === "percentage") {
		return discount.discount_type;
	}

	return membershipDiscountMoney(discount.discount_amount) > 0
		&& membershipDiscountMoney(discount.discount_percentage) <= 0
		? "amount"
		: "percentage";
};

const membershipDiscountBoolean = (value) => (
	[true, 1, "1", "true"].indexOf(value) !== -1
);

const membershipDiscountMatchesSkuClass = (discount, skuClass) => {
	const discountSkuClass = parseInt(discount.sku_class ?? discount.inventory_group ?? 0, 10);
	return membershipDiscountAppliesToAll(discount)
		|| (
			Number.isFinite(skuClass)
			&& skuClass > 0
			&& discountSkuClass === skuClass
		);
};

const membershipDiscountHasValue = (discount) => {
	const discountType = membershipDiscountType(discount);
	return discountType === "amount"
		? membershipDiscountMoney(discount.discount_amount) > 0
		: membershipDiscountMoney(discount.discount_percentage) > 0;
};

export const membershipDiscountsInPriorityOrder = (value) => {
	if (Array.isArray(value)) {
		return value;
	}
	if (!value) {
		return [];
	}

	try {
		const discounts = JSON.parse(value);
		return Array.isArray(discounts) ? discounts : [];
	} catch (error) {
		return [];
	}
};

export const membershipDiscountForLine = (
	discounts,
	skuClass,
	unitCost,
	quantity = 1,
	lineDiscount = 0,
) => {
	const normalizedSkuClass = parseInt(skuClass || 0, 10);
	const matchingDiscounts = membershipDiscountsInPriorityOrder(discounts).filter((discount) => (
		discount
		&& typeof discount === "object"
		&& membershipDiscountMatchesSkuClass(discount, normalizedSkuClass)
		&& membershipDiscountHasValue(discount)
	));
	const firstMatchingDiscount = matchingDiscounts[0];

	if (!firstMatchingDiscount) {
		return 0;
	}

	const normalizedQuantity = membershipDiscountMoney(quantity ?? 1);
	const lineBase = Math.max(
		0,
		(membershipDiscountMoney(unitCost) * normalizedQuantity) - membershipDiscountMoney(lineDiscount),
	);
	const firstMembership = parseInt(firstMatchingDiscount.membership || 0, 10);
	const discountsToApply = membershipDiscountBoolean(firstMatchingDiscount.membership_discounts_additive)
		? matchingDiscounts.filter((discount) => (
			parseInt(discount.membership || 0, 10) === firstMembership
		))
		: [firstMatchingDiscount];
	let remainingBase = lineBase;
	let membershipDiscount = 0;

	discountsToApply.forEach((discount) => {
		const discountType = membershipDiscountType(discount);
		const currentDiscount = discountType === "amount"
			? membershipDiscountMoney(discount.discount_amount) * normalizedQuantity
			: remainingBase * (membershipDiscountMoney(discount.discount_percentage) / 100);
		const appliedDiscount = Math.min(
			remainingBase,
			Math.max(0, Math.round(currentDiscount * 100) / 100),
		);
		membershipDiscount += appliedDiscount;
		remainingBase -= appliedDiscount;
	});

	return Math.round(Math.min(lineBase, membershipDiscount) * 100) / 100;
};
